module.exports = __webpack_public_path__ + "static/media/arrow-right-black.d8c3d51b.svg";